module.exports = __webpack_public_path__ + "img/0706-三层建筑-07-06.59115838.png";